// Comprehensive translations for all supported languages
export const allTranslations = {
	en_US: {
		"Accessibility Adjustments": "Accessibility Adjustments",
		"Adjust accessibility settings to improve your experience":
			"Adjust accessibility settings to improve your experience",
		"Content Scaling": "Content Scaling",
		"Text Size": "Text Size",
		"Line Height": "Line Height",
		"Letter Spacing": "Letter Spacing",
		"Color Adjustments": "Color Adjustments",
		Contrast: "Contrast",
		Saturation: "Saturation",
		Navigation: "Navigation",
		"Reading Features": "Reading Features",
		Premium: "Unlocked",
		light: "light",
		medium: "medium",
		heavy: "heavy",
		"Bigger Text": "Bigger Text",
		"Highlight Links": "Highlight Links",
		"Readable Font": "Readable Font",
		"Reading Mask": "Reading Mask",
		"Dyslexia Friendly": "Dyslexia Friendly",
		"Content Alignment": "Content Alignment",
		"Adjust Letter Spacing": "Adjust Letter Spacing",
		"Adjust Line Height": "Adjust Line Height",
		"Adjust Font Sizing": "Adjust Font Sizing",
		"Reset All": "Reset All",
		Close: "Close",
		"Select a profile that best fits your accessibility needs. Each profile enables a set of features designed to enhance user experience.":
			"Select a profile that best fits your accessibility needs. Each profile enables a set of features designed to enhance user experience.",
		// Accessibility profile translations
		"Choose an accessibility profile": "Choose an accessibility profile",
		"Motor Impaired": "Motor Impaired",
		"Blind Users": "Blind Users",
		"Color Blind": "Color Blind",
		Dyslexia: "Dyslexia",
		"Low vision": "Low vision",
		"Cognitive Learning": "Cognitive Learning",
		"Seizure & Epileptic": "Seizure & Epileptic",
		"ADHD  Profile": "ADHD  Profile",
		"Highlight Titles": "Highlight Titles",
		"Text Alignment": "Text Alignment",
		Dictionary: "Dictionary",
		Greyscale: "Greyscale",
		"Color Saturation": "Color Saturation",
		"Page Structure": "Page Structure",
		"Big Cursor": "Big Cursor",
		"Pointer Trail": "Pointer Trail",
		"Click Spark": "Click Spark",
		"Image Trails": "Image Trails",
		"Screen reader": "Screen reader",
		"Reading mask": "Reading mask",
		"Pause animations": "Pause animations",
		"Reading Guide": "Reading Guide",
		"Hide images": "Hide images",
		"Outline focus": "Outline focus",
		"Highlight Hover": "Highlight Hover",
		"Magnify Images": "Magnify Images",
		Tooltips: "Tooltips",
		// Category/Section titles
		"Content Adjustments": "Content Adjustments",
		"Navigation Adjustments": "Navigation Adjustments",
		"Orientation Adjustments": "Orientation Adjustments",
	},
	zh_CN: {
		"Accessibility Adjustments": "无障碍调整",
		"Adjust accessibility settings to improve your experience":
			"调整无障碍设置以改善您的体验",
		"Content Scaling": "内容缩放",
		"Text Size": "文字大小",
		"Line Height": "行高",
		"Letter Spacing": "字符间距",
		"Color Adjustments": "颜色调整",
		Contrast: "对比度",
		Saturation: "饱和度",
		Navigation: "导航",
		"Reading Features": "阅读功能",
		Premium: "高级版",
		light: "轻度",
		medium: "中度",
		heavy: "重度",
		"Bigger Text": "放大文字",
		"Highlight Links": "高亮链接",
		"Readable Font": "易读字体",
		"Reading Mask": "阅读遮罩",
		"Dyslexia Friendly": "阅读障碍友好",
		"Content Alignment": "内容对齐",
		"Adjust Letter Spacing": "调整字符间距",
		"Adjust Line Height": "调整行高",
		"Adjust Font Sizing": "调整字体大小",
		"Reset All": "重置全部",
		Close: "关闭",
		"Choose an accessibility profile": "选择无障碍配置文件",
		"Motor Impaired": "运动障碍",
		"Blind Users": "盲人用户",
		"Color Blind": "色盲",
		Dyslexia: "阅读障碍",
		"Low vision": "弱视",
		"Cognitive Learning": "认知与学习",
		"Seizure & Epileptic": "癫痫发作",
		"ADHD  Profile": "ADHD友好配置",
		"Highlight Titles": "突出标题",
		"Text Alignment": "文本对齐",
		Dictionary: "词典",
		Greyscale: "灰度",
		"Color Saturation": "颜色饱和度",
		"Page Structure": "页面结构",
		"Big Cursor": "大光标",
		"Pointer Trail": "指针轨迹",
		"Click Spark": "点击火花",
		"Image Trails": "图像轨迹",
		"Screen reader": "屏幕阅读器",
		"Reading mask": "阅读遮罩",
		"Pause animations": "暂停动画",
		"Reading Guide": "阅读指南",
		"Hide images": "隐藏图像",
		"Outline focus": "轮廓焦点",
		"Highlight Hover": "突出悬停",
		"Magnify Images": "放大图像",
		Tooltips: "工具提示",
		// Category/Section titles
		"Content Adjustments": "内容调整",
		"Navigation Adjustments": "导航调整",
		"Orientation Adjustments": "方向调整",
	},
	es_ES: {
		"Accessibility Adjustments": "Ajustes de Accesibilidad",
		"Adjust accessibility settings to improve your experience":
			"Ajusta la configuración de accesibilidad para mejorar tu experiencia",
		"Content Scaling": "Escalado de Contenido",
		"Text Size": "Tamaño de Texto",
		"Line Height": "Altura de Línea",
		"Letter Spacing": "Espaciado de Letras",
		"Color Adjustments": "Ajustes de Color",
		Contrast: "Contraste",
		Saturation: "Saturación",
		Navigation: "Navegación",
		"Reading Features": "Funciones de Lectura",
		Premium: "Premium",
		light: "ligero",
		medium: "medio",
		heavy: "pesado",
		"Bigger Text": "Texto Más Grande",
		"Highlight Links": "Resaltar Enlaces",
		"Readable Font": "Fuente Legible",
		"Reading Mask": "Máscara de Lectura",
		"Dyslexia Friendly": "Amigable para Dislexia",
		"Content Alignment": "Alineación de Contenido",
		"Adjust Letter Spacing": "Ajustar Espaciado de Letras",
		"Adjust Line Height": "Ajustar Altura de Línea",
		"Adjust Font Sizing": "Ajustar Tamaño de Fuente",
		"Reset All": "Restablecer Todo",
		Close: "Cerrar",
		"Choose an accessibility profile": "Elige un perfil de accesibilidad",
		"Motor Impaired": "Discapacidad Motora",
		"Blind Users": "Usuarios Ciegos",
		"Color Blind": "Daltónico",
		Dyslexia: "Dislexia",
		"Low vision": "Baja visión",
		"Cognitive Learning": "Cognitivo y Aprendizaje",
		"Seizure & Epileptic": "Convulsiones y Epilepsia",
		"ADHD  Profile": "Perfil Amigable TDAH",
		"Highlight Titles": "Resaltar Títulos",
		"Text Alignment": "Alineación de Texto",
		Dictionary: "Diccionario",
		Greyscale: "Escala de Grises",
		"Color Saturation": "Saturación de Color",
		"Page Structure": "Estructura de Página",
		"Big Cursor": "Cursor Grande",
		"Pointer Trail": "Rastro del Puntero",
		"Click Spark": "Chispa de Clic",
		"Image Trails": "Rastros de Imagen",
		"Screen reader": "Lector de pantalla",
		"Reading mask": "Máscara de lectura",
		"Pause animations": "Pausar animaciones",
		"Reading Guide": "Guía de Lectura",
		"Hide images": "Ocultar imágenes",
		"Outline focus": "Contorno de enfoque",
		"Highlight Hover": "Resaltar al pasar",
		"Magnify Images": "Ampliar Imágenes",
		Tooltips: "Consejos de herramientas",
		// Category/Section titles
		"Content Adjustments": "Ajustes de Contenido",
		"Navigation Adjustments": "Ajustes de Navegación",
		"Orientation Adjustments": "Ajustes de Orientación",
	},
	de_DE: {
		"Accessibility Adjustments": "Barrierefreiheit-Anpassungen",
		"Adjust accessibility settings to improve your experience":
			"Passen Sie die Barrierefreiheitseinstellungen an, um Ihre Erfahrung zu verbessern",
		"Content Scaling": "Inhaltsskalierung",
		"Text Size": "Textgröße",
		"Line Height": "Zeilenhöhe",
		"Letter Spacing": "Buchstabenabstand",
		"Color Adjustments": "Farbanpassungen",
		Contrast: "Kontrast",
		Saturation: "Sättigung",
		Navigation: "Navigation",
		"Reading Features": "Lesefunktionen",
		Premium: "Premium",
		light: "leicht",
		medium: "mittel",
		heavy: "schwer",
		"Bigger Text": "Größerer Text",
		"Highlight Links": "Links hervorheben",
		"Readable Font": "Lesbare Schrift",
		"Reading Mask": "Lesemaske",
		"Dyslexia Friendly": "Legasthenie-freundlich",
		"Content Alignment": "Inhaltsausrichtung",
		"Adjust Letter Spacing": "Buchstabenabstand anpassen",
		"Adjust Line Height": "Zeilenhöhe anpassen",
		"Adjust Font Sizing": "Schriftgröße anpassen",
		"Reset All": "Alles zurücksetzen",
		Close: "Schließen",
		"Choose an accessibility profile": "Wählen Sie ein Barrierefreiheitsprofil",
		"Motor Impaired": "Motorische Beeinträchtigung",
		"Blind Users": "Blinde Benutzer",
		"Color Blind": "Farbenblind",
		Dyslexia: "Legasthenie",
		"Low vision": "Sehschwäche",
		"Cognitive Learning": "Kognitiv und Lernen",
		"Seizure & Epileptic": "Anfälle und Epilepsie",
		"ADHD  Profile": "ADHS-freundliches Profil",
		"Highlight Titles": "Titel hervorheben",
		"Text Alignment": "Textausrichtung",
		Dictionary: "Wörterbuch",
		Greyscale: "Graustufen",
		"Color Saturation": "Farbsättigung",
		"Page Structure": "Seitenstruktur",
		"Big Cursor": "Großer Cursor",
		"Pointer Trail": "Zeiger-Spur",
		"Click Spark": "Klick-Funken",
		"Image Trails": "Bildspuren",
		"Screen reader": "Bildschirmleser",
		"Reading mask": "Lesemaske",
		"Pause animations": "Animationen pausieren",
		"Reading Guide": "Lesehilfe",
		"Hide images": "Bilder ausblenden",
		"Outline focus": "Umriss-Fokus",
		"Highlight Hover": "Hover hervorheben",
		"Magnify Images": "Bilder vergrößern",
		Tooltips: "Tooltips",
		// Category/Section titles
		"Content Adjustments": "Inhaltsanpassungen",
		"Navigation Adjustments": "Navigationsanpassungen",
		"Orientation Adjustments": "Orientierungsanpassungen",
	},
	fr_FR: {
		"Accessibility Adjustments": "Réglages d'accessibilité",
		"Adjust accessibility settings to improve your experience":
			"Ajustez les paramètres d'accessibilité pour améliorer votre expérience",
		"Content Scaling": "Mise à l'échelle du contenu",
		"Text Size": "Taille du texte",
		"Line Height": "Hauteur de ligne",
		"Letter Spacing": "Espacement des lettres",
		"Color Adjustments": "Ajustements de couleur",
		Contrast: "Contraste",
		Saturation: "Saturation",
		Navigation: "Navigation",
		"Reading Features": "Fonctionnalités de lecture",
		Premium: "Premium",
		light: "léger",
		medium: "moyen",
		heavy: "lourd",
		"Bigger Text": "Texte plus grand",
		"Highlight Links": "Surligner les liens",
		"Readable Font": "Police lisible",
		"Reading Mask": "Masque de lecture",
		"Dyslexia Friendly": "Convivial dyslexie",
		"Content Alignment": "Alignement du contenu",
		"Adjust Letter Spacing": "Ajuster l'espacement des lettres",
		"Adjust Line Height": "Ajuster la hauteur de ligne",
		"Adjust Font Sizing": "Ajuster la taille de police",
		"Reset All": "Tout réinitialiser",
		Close: "Fermer",
		// new
		"Choose an accessibility profile": "Choisir un profil d'accessibilité",
		"Motor Impaired": "Déficience motrice",
		"Blind Users": "Utilisateurs aveugles",
		"Color Blind": "Daltonisme",
		Dyslexia: "Dyslexie",
		"Low vision": "Malvoyance",
		"Cognitive Learning": "Cognitif et apprentissage",
		"Seizure & Epileptic": "Crise et épilepsie",
		"ADHD  Profile": "Profil convivial TDAH",
		"Highlight Titles": "Surligner les titres",
		"Text Alignment": "Alignement du texte",
		Dictionary: "Dictionnaire",
		Greyscale: "Niveaux de gris",
		"Color Saturation": "Saturation des couleurs",
		"Page Structure": "Structure de la page",
		"Big Cursor": "Gros curseur",
		"Pointer Trail": "Traînée du pointeur",
		"Click Spark": "Étincelle de clic",
		"Image Trails": "Traînées d'images",
		"Screen reader": "Lecteur d'écran",
		"Reading mask": "Masque de lecture",
		"Pause animations": "Suspendre les animations",
		"Reading Guide": "Guide de lecture",
		"Hide images": "Masquer les images",
		"Outline focus": "Contour de focus",
		"Highlight Hover": "Surlignage au survol",
		"Magnify Images": "Agrandir les images",
		Tooltips: "Infobulles",
		// Category/Section titles
		"Content Adjustments": "Ajustements de Contenu",
		"Navigation Adjustments": "Ajustements de Navigation",
		"Orientation Adjustments": "Ajustements d'Orientation",
	},
	pt_PT: {
		"Accessibility Adjustments": "Ajustes de Acessibilidade",
		"Adjust accessibility settings to improve your experience":
			"Ajuste as configurações de acessibilidade para melhorar sua experiência",
		"Content Scaling": "Dimensionamento de Conteúdo",
		"Text Size": "Tamanho do Texto",
		"Line Height": "Altura da Linha",
		"Letter Spacing": "Espaçamento de Letras",
		"Color Adjustments": "Ajustes de Cor",
		Contrast: "Contraste",
		Saturation: "Saturação",
		Navigation: "Navegação",
		"Reading Features": "Recursos de Leitura",
		Premium: "Premium",
		light: "leve",
		medium: "médio",
		heavy: "pesado",
		"Bigger Text": "Texto Maior",
		"Highlight Links": "Destacar Links",
		"Readable Font": "Fonte Legível",
		"Reading Mask": "Máscara de Leitura",
		"Dyslexia Friendly": "Amigável para Dislexia",
		"Content Alignment": "Alinhamento de Conteúdo",
		"Adjust Letter Spacing": "Ajustar Espaçamento de Letras",
		"Adjust Line Height": "Ajustar Altura da Linha",
		"Adjust Font Sizing": "Ajustar Tamanho da Fonte",
		"Reset All": "Redefinir Tudo",
		Close: "Fechar",
		"Choose an accessibility profile": "Escolha um perfil de acessibilidade",
		"Motor Impaired": "Deficiência Motora",
		"Blind Users": "Usuários Cegos",
		"Color Blind": "Daltônico",
		Dyslexia: "Dislexia",
		"Low vision": "Baixa visão",
		"Cognitive Learning": "Cognitivo e Aprendizagem",
		"Seizure & Epileptic": "Convulsões e Epilepsia",
		"ADHD  Profile": "Perfil Amigável TDAH",
		"Highlight Titles": "Destacar Títulos",
		"Text Alignment": "Alinhamento de Texto",
		Dictionary: "Dicionário",
		Greyscale: "Escala de Cinza",
		"Color Saturation": "Saturação de Cor",
		"Page Structure": "Estrutura da Página",
		"Big Cursor": "Cursor Grande",
		"Pointer Trail": "Trilha do Ponteiro",
		"Click Spark": "Faísca de Clique",
		"Image Trails": "Trilhas de Imagem",
		"Screen reader": "Leitor de tela",
		"Reading mask": "Máscara de leitura",
		"Pause animations": "Pausar animações",
		"Reading Guide": "Guia de Leitura",
		"Hide images": "Ocultar imagens",
		"Outline focus": "Contorno de foco",
		"Highlight Hover": "Destacar ao passar",
		"Magnify Images": "Ampliar Imagens",
		Tooltips: "Dicas de ferramentas",
		// Category/Section titles
		"Content Adjustments": "Ajustes de Conteúdo",
		"Navigation Adjustments": "Ajustes de Navegação",
		"Orientation Adjustments": "Ajustes de Orientação",
	},
	ru_RU: {
		"Accessibility Adjustments": "Настройки доступности",
		"Adjust accessibility settings to improve your experience":
			"Настройте параметры доступности для улучшения вашего опыта",
		"Content Scaling": "Масштабирование контента",
		"Text Size": "Размер текста",
		"Line Height": "Высота строки",
		"Letter Spacing": "Интервал между буквами",
		"Color Adjustments": "Настройки цвета",
		Contrast: "Контрастность",
		Saturation: "Насыщенность",
		Navigation: "Навигация",
		"Reading Features": "Функции чтения",
		Premium: "Премиум",
		light: "легкий",
		medium: "средний",
		heavy: "тяжелый",
		"Bigger Text": "Увеличить текст",
		"Highlight Links": "Выделить ссылки",
		"Readable Font": "Читаемый шрифт",
		"Reading Mask": "Маска чтения",
		"Dyslexia Friendly": "Дружелюбно к дислексии",
		"Content Alignment": "Выравнивание контента",
		"Adjust Letter Spacing": "Настроить интервал между буквами",
		"Adjust Line Height": "Настроить высоту строки",
		"Adjust Font Sizing": "Настроить размер шрифта",
		"Reset All": "Сбросить все",
		Close: "Закрыть",
		// new
		"Choose an accessibility profile": "Выберите профиль доступности",
		"Motor Impaired": "Нарушения моторики",
		"Blind Users": "Слепые пользователи",
		"Color Blind": "Дальтонизм",
		Dyslexia: "Дислексия",
		"Low vision": "Слабое зрение",
		"Cognitive Learning": "Когнитивные и обучающие",
		"Seizure & Epileptic": "Судороги и эпилепсия",
		"ADHD  Profile": "Профиль для СДВГ",
		"Highlight Titles": "Выделить заголовки",
		"Text Alignment": "Выравнивание текста",
		Dictionary: "Словарь",
		Greyscale: "Оттенки серого",
		"Color Saturation": "Насыщенность цвета",
		"Page Structure": "Структура страницы",
		"Big Cursor": "Большой курсор",
		"Pointer Trail": "След указателя",
		"Click Spark": "Искры клика",
		"Image Trails": "Следы изображений",
		"Screen reader": "Программа чтения с экрана",
		"Reading mask": "Маска чтения",
		"Pause animations": "Приостановить анимации",
		"Reading Guide": "Руководство по чтению",
		"Hide images": "Скрыть изображения",
		"Outline focus": "Контур фокуса",
		"Highlight Hover": "Выделить при наведении",
		"Magnify Images": "Увеличить изображения",
		Tooltips: "Подсказки",
		// Category/Section titles
		"Content Adjustments": "Настройки контента",
		"Navigation Adjustments": "Настройки навигации",
		"Orientation Adjustments": "Настройки ориентации",
	},
	ja_JP: {
		"Accessibility Adjustments": "アクセシビリティ調整",
		"Adjust accessibility settings to improve your experience":
			"アクセシビリティ設定を調整して体験を向上させる",
		"Content Scaling": "コンテンツスケーリング",
		"Text Size": "テキストサイズ",
		"Line Height": "行の高さ",
		"Letter Spacing": "文字間隔",
		"Color Adjustments": "色調整",
		Contrast: "コントラスト",
		Saturation: "彩度",
		Navigation: "ナビゲーション",
		"Reading Features": "読書機能",
		Premium: "プレミアム",
		light: "ライト",
		medium: "ミディアム",
		heavy: "ヘビー",
		"Bigger Text": "テキストを大きく",
		"Highlight Links": "リンクをハイライト",
		"Readable Font": "読みやすいフォント",
		"Reading Mask": "読書マスク",
		"Dyslexia Friendly": "ディスレクシア対応",
		"Content Alignment": "コンテンツ配置",
		"Adjust Letter Spacing": "文字間隔を調整",
		"Adjust Line Height": "行の高さを調整",
		"Adjust Font Sizing": "フォントサイズを調整",
		"Reset All": "すべてリセット",
		Close: "閉じる",
		// new
		"Choose an accessibility profile": "アクセシビリティプロファイルを選択",
		"Motor Impaired": "運動障害",
		"Blind Users": "視覚障害者",
		"Color Blind": "色覚障害",
		Dyslexia: "読字障害",
		"Low vision": "弱視",
		"Cognitive Learning": "認知・学習障害",
		"Seizure & Epileptic": "けいれん・てんかん",
		"ADHD  Profile": "ADHD対応プロファイル",
		"Highlight Titles": "タイトルをハイライト",
		"Text Alignment": "テキスト配置",
		Dictionary: "辞書",
		Greyscale: "グレースケール",
		"Color Saturation": "色彩度",
		"Page Structure": "ページ構造",
		"Big Cursor": "大きなカーソル",
		"Pointer Trail": "ポインタートレイル",
		"Click Spark": "クリックスパーク",
		"Image Trails": "画像トレイル",
		"Screen reader": "スクリーンリーダー",
		"Reading mask": "読書マスク",
		"Pause animations": "アニメーション一時停止",
		"Reading Guide": "読書ガイド",
		"Hide images": "画像を非表示",
		"Outline focus": "フォーカス枠線",
		"Highlight Hover": "ホバーハイライト",
		"Magnify Images": "画像拡大",
		Tooltips: "ツールチップ",
		// Category/Section titles
		"Content Adjustments": "コンテンツ調整",
		"Navigation Adjustments": "ナビゲーション調整",
		"Orientation Adjustments": "方向調整",
	},
	ko_KR: {
		"Accessibility Adjustments": "접근성 조정",
		"Adjust accessibility settings to improve your experience":
			"접근성 설정을 조정하여 경험을 개선하세요",
		"Content Scaling": "콘텐츠 크기 조정",
		"Text Size": "텍스트 크기",
		"Line Height": "줄 높이",
		"Letter Spacing": "글자 간격",
		"Color Adjustments": "색상 조정",
		Contrast: "대비",
		Saturation: "채도",
		Navigation: "내비게이션",
		"Reading Features": "읽기 기능",
		Premium: "프리미엄",
		light: "가벼움",
		medium: "보통",
		heavy: "무거움",
		"Bigger Text": "큰 텍스트",
		"Highlight Links": "링크 강조",
		"Readable Font": "읽기 쉬운 폰트",
		"Reading Mask": "읽기 마스크",
		"Dyslexia Friendly": "난독증 친화적",
		"Content Alignment": "콘텐츠 정렬",
		"Adjust Letter Spacing": "글자 간격 조정",
		"Adjust Line Height": "줄 높이 조정",
		"Adjust Font Sizing": "폰트 크기 조정",
		"Reset All": "모두 재설정",
		Close: "닫기",
		// new
		"Choose an accessibility profile": "접근성 프로필 선택",
		"Motor Impaired": "운동 장애",
		"Blind Users": "시각 장애인",
		"Color Blind": "색맹",
		Dyslexia: "난독증",
		"Low vision": "저시력",
		"Cognitive Learning": "인지 및 학습 장애",
		"Seizure & Epileptic": "발작 및 간질",
		"ADHD  Profile": "ADHD 친화 프로필",
		"Highlight Titles": "제목 강조",
		"Text Alignment": "텍스트 정렬",
		Dictionary: "사전",
		Greyscale: "그레이스케일",
		"Color Saturation": "색상 채도",
		"Page Structure": "페이지 구조",
		"Big Cursor": "큰 커서",
		"Pointer Trail": "포인터 트레일",
		"Click Spark": "클릭 스파크",
		"Image Trails": "이미지 트레일",
		"Screen reader": "스크린 리더",
		"Reading mask": "읽기 마스크",
		"Pause animations": "애니메이션 일시 정지",
		"Reading Guide": "읽기 가이드",
		"Hide images": "이미지 숨기기",
		"Outline focus": "포커스 아웃라인",
		"Highlight Hover": "호버 강조",
		"Magnify Images": "이미지 확대",
		Tooltips: "툴팁",
		// Category/Section titles
		"Content Adjustments": "콘텐츠 조정",
		"Navigation Adjustments": "내비게이션 조정",
		"Orientation Adjustments": "방향 조정",
	},
	ar_SA: {
		"Accessibility Adjustments": "تعديلات إمكانية الوصول",
		"Adjust accessibility settings to improve your experience":
			"اضبط إعدادات إمكانية الوصول لتحسين تجربتك",
		"Content Scaling": "تحجيم المحتوى",
		"Text Size": "حجم النص",
		"Line Height": "ارتفاع السطر",
		"Letter Spacing": "تباعد الأحرف",
		"Color Adjustments": "تعديلات الألوان",
		Contrast: "التباين",
		Saturation: "التشبع",
		Navigation: "التنقل",
		"Reading Features": "ميزات القراءة",
		Premium: "مميز",
		light: "خفيف",
		medium: "متوسط",
		heavy: "ثقيل",
		"Bigger Text": "نص أكبر",
		"Highlight Links": "تسليط الضوء على الروابط",
		"Readable Font": "خط قابل للقراءة",
		"Reading Mask": "قناع القراءة",
		"Dyslexia Friendly": "صديق عسر القراءة",
		"Content Alignment": "محاذاة المحتوى",
		"Adjust Letter Spacing": "ضبط تباعد الأحرف",
		"Adjust Line Height": "ضبط ارتفاع السطر",
		"Adjust Font Sizing": "ضبط حجم الخط",
		"Reset All": "إعادة تعيين الكل",
		Close: "إغلاق",
		// new
		"Choose an accessibility profile": "اختر ملف تعريف إمكانية الوصول",
		"Motor Impaired": "ضعف حركي",
		"Blind Users": "المستخدمون المكفوفون",
		"Color Blind": "عمى الألوان",
		Dyslexia: "عسر القراءة",
		"Low vision": "ضعف البصر",
		"Cognitive Learning": "المعرفية والتعلم",
		"Seizure & Epileptic": "النوبات والصرع",
		"ADHD  Profile": "ملف تعريف ADHD الودود",
		"Highlight Titles": "تسليط الضوء على العناوين",
		"Text Alignment": "محاذاة النص",
		Dictionary: "قاموس",
		Greyscale: "رمادي",
		"Color Saturation": "تشبع اللون",
		"Page Structure": "هيكل الصفحة",
		"Big Cursor": "مؤشر كبير",
		"Pointer Trail": "أثر المؤشر",
		"Click Spark": "شرارة النقر",
		"Image Trails": "آثار الصور",
		"Screen reader": "قارئ الشاشة",
		"Reading mask": "قناع القراءة",
		"Pause animations": "إيقاف الرسوم المتحركة مؤقتاً",
		"Reading Guide": "دليل القراءة",
		"Hide images": "إخفاء الصور",
		"Outline focus": "حدود التركيز",
		"Highlight Hover": "تسليط الضوء على التمرير",
		"Magnify Images": "تكبير الصور",
		Tooltips: "تلميحات الأدوات",
		// Category/Section titles
		"Content Adjustments": "تعديلات المحتوى",
		"Navigation Adjustments": "تعديلات التنقل",
		"Orientation Adjustments": "تعديلات الاتجاه",
	},
	hi_IN: {
		"Accessibility Adjustments": "पहुंच समायोजन",
		"Adjust accessibility settings to improve your experience":
			"अपने अनुभव को बेहतर बनाने के लिए पहुंच सेटिंग्स समायोजित करें",
		"Content Scaling": "सामग्री स्केलिंग",
		"Text Size": "टेक्स्ट का आकार",
		"Line Height": "लाइन की ऊंचाई",
		"Letter Spacing": "अक्षर अंतराल",
		"Color Adjustments": "रंग समायोजन",
		Contrast: "कंट्रास्ट",
		Saturation: "संतृप्ति",
		Navigation: "नेवीगेशन",
		"Reading Features": "पढ़ने की सुविधाएं",
		Premium: "प्रीमियम",
		light: "हल्का",
		medium: "मध्यम",
		heavy: "भारी",
		"Bigger Text": "बड़ा टेक्स्ट",
		"Highlight Links": "लिंक हाइलाइट करें",
		"Readable Font": "पढ़ने योग्य फ़ॉन्ट",
		"Reading Mask": "रीडिंग मास्क",
		"Dyslexia Friendly": "डिस्लेक्सिया मित्र",
		"Content Alignment": "सामग्री संरेखण",
		"Adjust Letter Spacing": "अक्षर अंतराल समायोजित करें",
		"Adjust Line Height": "लाइन की ऊंचाई समायोजित करें",
		"Adjust Font Sizing": "फ़ॉन्ट आकार समायोजित करें",
		"Reset All": "सभी रीसेट करें",
		Close: "बंद करें",
		// new
		"Choose an accessibility profile": "एक एक्सेसिबिलिटी प्रोफ़ाइल चुनें",
		"Motor Impaired": "मोटर दुर्बलता",
		"Blind Users": "नेत्रहीन उपयोगकर्ता",
		"Color Blind": "वर्णांधता",
		Dyslexia: "डिस्लेक्सिया",
		"Low vision": "कम दृष्टि",
		"Cognitive Learning": "संज्ञानात्मक और सीखना",
		"Seizure & Epileptic": "दौरे और मिर्गी",
		"ADHD  Profile": "ADHD मित्र प्रोफ़ाइल",
		"Highlight Titles": "शीर्षक हाइलाइट करें",
		"Text Alignment": "टेक्स्ट संरेखण",
		Dictionary: "शब्दकोश",
		Greyscale: "ग्रेस्केल",
		"Color Saturation": "रंग संतृप्ति",
		"Page Structure": "पृष्ठ संरचना",
		"Big Cursor": "बड़ा कर्सर",
		"Pointer Trail": "पॉइंटर ट्रेल",
		"Click Spark": "क्लिक स्पार्क",
		"Image Trails": "छवि ट्रेल्स",
		"Screen reader": "स्क्रीन रीडर",
		"Reading mask": "रीडिंग मास्क",
		"Pause animations": "एनिमेशन रोकें",
		"Reading Guide": "पढ़ने की मार्गदर्शिका",
		"Hide images": "छवियां छुपाएं",
		"Outline focus": "आउटलाइन फ़ोकस",
		"Highlight Hover": "होवर हाइलाइट",
		"Magnify Images": "छवियां बड़ी करें",
		Tooltips: "टूलटिप्स",
		// Category/Section titles
		"Content Adjustments": "सामग्री समायोजन",
		"Navigation Adjustments": "नेवीगेशन समायोजन",
		"Orientation Adjustments": "अभिविन्यास समायोजन",
	},
	bn_BD: {
		"Accessibility Adjustments": "অ্যাক্সেসিবিলিটি সমন্বয়",
		"Adjust accessibility settings to improve your experience":
			"আপনার অভিজ্ঞতা উন্নত করতে অ্যাক্সেসিবিলিটি সেটিংস সমন্বয় করুন",
		"Content Scaling": "কন্টেন্ট স্কেলিং",
		"Text Size": "টেক্সটের আকার",
		"Line Height": "লাইনের উচ্চতা",
		"Letter Spacing": "অক্ষরের ব্যবধান",
		"Color Adjustments": "রঙের সমন্বয়",
		Contrast: "কনট্রাস্ট",
		Saturation: "স্যাচুরেশন",
		Navigation: "নেভিগেশন",
		"Reading Features": "পড়ার বৈশিষ্ট্য",
		Premium: "প্রিমিয়াম",
		light: "হালকা",
		medium: "মাঝারি",
		heavy: "ভারী",
		"Bigger Text": "বড় টেক্সট",
		"Highlight Links": "লিংক হাইলাইট",
		"Readable Font": "পড়ার উপযোগী ফন্ট",
		"Reading Mask": "রিডিং মাস্ক",
		"Dyslexia Friendly": "ডিসলেক্সিয়া ফ্রেন্ডলি",
		"Content Alignment": "কন্টেন্ট সাজানো",
		"Adjust Letter Spacing": "অক্ষরের ব্যবধান সমন্বয়",
		"Adjust Line Height": "লাইনের উচ্চতা সমন্বয়",
		"Adjust Font Sizing": "ফন্টের আকার সমন্বয়",
		"Reset All": "সব রিসেট করুন",
		Close: "বন্ধ করুন",
		// new
		"Choose an accessibility profile":
			"একটি অ্যাক্সেসিবিলিটি প্রোফাইল বেছে নিন",
		"Motor Impaired": "মোটর প্রতিবন্ধী",
		"Blind Users": "অন্ধ ব্যবহারকারী",
		"Color Blind": "বর্ণান্ধ",
		Dyslexia: "ডিসলেক্সিয়া",
		"Low vision": "কম দৃষ্টি",
		"Cognitive Learning": "জ্ঞানীয় এবং শেখার",
		"Seizure & Epileptic": "খিঁচুনি এবং মৃগীরোগ",
		"ADHD  Profile": "ADHD বান্ধব প্রোফাইল",
		"Highlight Titles": "শিরোনাম হাইলাইট করুন",
		"Text Alignment": "টেক্সট সারিবদ্ধতা",
		Dictionary: "অভিধান",
		Greyscale: "গ্রেস্কেল",
		"Color Saturation": "রঙের স্যাচুরেশন",
		"Page Structure": "পাতার গঠন",
		"Big Cursor": "বড় কার্সার",
		"Pointer Trail": "পয়েন্টার ট্রেইল",
		"Click Spark": "ক্লিক স্পার্ক",
		"Image Trails": "ইমেজ ট্রেইল",
		"Screen reader": "স্ক্রিন রিডার",
		"Reading mask": "রিডিং মাস্ক",
		"Pause animations": "অ্যানিমেশন বিরাম দিন",
		"Reading Guide": "পড়ার গাইড",
		"Hide images": "ছবি লুকান",
		"Outline focus": "আউটলাইন ফোকাস",
		"Highlight Hover": "হোভার হাইলাইট",
		"Magnify Images": "ছবি বড় করুন",
		Tooltips: "টুলটিপস",
		// Category/Section titles
		"Content Adjustments": "কন্টেন্ট সমন্বয়",
		"Navigation Adjustments": "নেভিগেশন সমন্বয়",
		"Orientation Adjustments": "অভিমুখ সমন্বয়",
	},
	ur_PK: {
		"Accessibility Adjustments": "رسائی کی ترتیبات",
		"Adjust accessibility settings to improve your experience":
			"اپنے تجربے کو بہتر بنانے کے لیے رسائی کی ترتیبات کو ایڈجسٹ کریں",
		"Content Scaling": "مواد کی پیمائی",
		"Text Size": "متن کا سائز",
		"Line Height": "لائن کی اونچائی",
		"Letter Spacing": "حروف کی جگہ",
		"Color Adjustments": "رنگ کی ترتیبات",
		Contrast: "تضاد",
		Saturation: "سیرافگنی",
		Navigation: "نیویگیشن",
		"Reading Features": "پڑھنے کی خصوصیات",
		Premium: "پریمیم",
		light: "ہلکا",
		medium: "درمیانہ",
		heavy: "بھاری",
		"Bigger Text": "بڑا متن",
		"Highlight Links": "لنکس کو نمایاں کریں",
		"Readable Font": "پڑھنے کے قابل فونٹ",
		"Reading Mask": "پڑھنے کا ماسک",
		"Dyslexia Friendly": "ڈسلیکسیا دوست",
		"Content Alignment": "مواد کی ترتیب",
		"Adjust Letter Spacing": "حروف کی جگہ ایڈجسٹ کریں",
		"Adjust Line Height": "لائن کی اونچائی ایڈجسٹ کریں",
		"Adjust Font Sizing": "فونٹ کا سائز ایڈجسٹ کریں",
		"Reset All": "سب ری سیٹ کریں",
		Close: "بند کریں",
		// new
		"Choose an accessibility profile": "ایک رسائی پروفائل منتخب کریں",
		"Motor Impaired": "موٹر معذور",
		"Blind Users": "نابینا صارفین",
		"Color Blind": "رنگ اندھے",
		Dyslexia: "ڈسلیکسیا",
		"Low vision": "کم بصارت",
		"Cognitive Learning": "علمی اور تعلیمی",
		"Seizure & Epileptic": "دورہ اور مرگی",
		"ADHD  Profile": "ADHD دوست پروفائل",
		"Highlight Titles": "عنوانات کو نمایاں کریں",
		"Text Alignment": "متن کی ترتیب",
		Dictionary: "لغت",
		Greyscale: "خاکستری",
		"Color Saturation": "رنگ کی سیرافگنی",
		"Page Structure": "صفحہ کی ساخت",
		"Big Cursor": "بڑا کرسر",
		"Pointer Trail": "پوائنٹر ٹریل",
		"Click Spark": "کلک چنگاری",
		"Image Trails": "تصویری پگڈنڈیاں",
		"Screen reader": "اسکرین ریڈر",
		"Reading mask": "پڑھنے کا ماسک",
		"Pause animations": "حرکت پذیری روکیں",
		"Reading Guide": "پڑھنے کی رہنمائی",
		"Hide images": "تصاویر چھپائیں",
		"Outline focus": "آؤٹ لائن فوکس",
		"Highlight Hover": "ہوور ہائی لائٹ",
		"Magnify Images": "تصاویر بڑھائیں",
		Tooltips: "ٹول ٹپس",
		// Category/Section titles
		"Content Adjustments": "مواد کی تبدیلیاں",
		"Navigation Adjustments": "نیویگیشن تبدیلیاں",
		"Orientation Adjustments": "سمت کی تبدیلیاں",
	},
	tr_TR: {
		"Accessibility Adjustments": "Erişilebilirlik Ayarları",
		"Adjust accessibility settings to improve your experience":
			"Deneyiminizi iyileştirmek için erişilebilirlik ayarlarını düzenleyin",
		"Content Scaling": "İçerik Ölçeklendirme",
		"Text Size": "Metin Boyutu",
		"Line Height": "Satır Yüksekliği",
		"Letter Spacing": "Harf Aralığı",
		"Color Adjustments": "Renk Ayarları",
		Contrast: "Kontrast",
		Saturation: "Doygunluk",
		Navigation: "Navigasyon",
		"Reading Features": "Okuma Özellikleri",
		Premium: "Premium",
		light: "hafif",
		medium: "orta",
		heavy: "ağır",
		"Bigger Text": "Daha Büyük Metin",
		"Highlight Links": "Bağlantıları Vurgula",
		"Readable Font": "Okunabilir Yazı Tipi",
		"Reading Mask": "Okuma Maskesi",
		"Dyslexia Friendly": "Disleksi Dostu",
		"Content Alignment": "İçerik Hizalama",
		"Adjust Letter Spacing": "Harf Aralığını Ayarla",
		"Adjust Line Height": "Satır Yüksekliğini Ayarla",
		"Adjust Font Sizing": "Yazı Boyutunu Ayarla",
		"Reset All": "Tümünü Sıfırla",
		Close: "Kapat",
		// new
		"Choose an accessibility profile": "Bir erişilebilirlik profili seçin",
		"Motor Impaired": "Motor Engelli",
		"Blind Users": "Görme Engelli Kullanıcılar",
		"Color Blind": "Renk Körlüğü",
		Dyslexia: "Disleksi",
		"Low vision": "Düşük görme",
		"Cognitive Learning": "Bilişsel ve Öğrenme",
		"Seizure & Epileptic": "Nöbet ve Epilepsi",
		"ADHD  Profile": "ADHD Dostu Profil",
		"Highlight Titles": "Başlıkları Vurgula",
		"Text Alignment": "Metin Hizalama",
		Dictionary: "Sözlük",
		Greyscale: "Gri tonlama",
		"Color Saturation": "Renk Doygunluğu",
		"Page Structure": "Sayfa Yapısı",
		"Big Cursor": "Büyük İmleç",
		"Pointer Trail": "İşaretçi İzi",
		"Click Spark": "Tıklama Kıvılcımı",
		"Image Trails": "Görüntü İzleri",
		"Screen reader": "Ekran okuyucu",
		"Reading mask": "Okuma maskesi",
		"Pause animations": "Animasyonları duraklat",
		"Reading Guide": "Okuma Rehberi",
		"Hide images": "Resimleri gizle",
		"Outline focus": "Odak çerçevesi",
		"Highlight Hover": "Üzerine gelme vurgusu",
		"Magnify Images": "Resimleri büyüt",
		Tooltips: "Araç ipuçları",
		// Category/Section titles
		"Content Adjustments": "İçerik Ayarları",
		"Navigation Adjustments": "Navigasyon Ayarları",
		"Orientation Adjustments": "Yönlendirme Ayarları",
	},
	nl_NL: {
		"Accessibility Adjustments": "Toegankelijkheidsaanpassingen",
		"Adjust accessibility settings to improve your experience":
			"Pas toegankelijkheidsinstellingen aan om uw ervaring te verbeteren",
		"Content Scaling": "Inhoudsschaling",
		"Text Size": "Tekstgrootte",
		"Line Height": "Regelhoogte",
		"Letter Spacing": "Letterafstand",
		"Color Adjustments": "Kleurcorrecties",
		Contrast: "Contrast",
		Saturation: "Verzadiging",
		Navigation: "Navigatie",
		"Reading Features": "Leesfuncties",
		Premium: "Premium",
		light: "licht",
		medium: "gemiddeld",
		heavy: "zwaar",
		"Bigger Text": "Grotere Tekst",
		"Highlight Links": "Links Markeren",
		"Readable Font": "Leesbaar Lettertype",
		"Reading Mask": "Leesmasker",
		"Dyslexia Friendly": "Dyslexievriendelijk",
		"Content Alignment": "Inhoud Uitlijning",
		"Adjust Letter Spacing": "Letterafstand Aanpassen",
		"Adjust Line Height": "Regelhoogte Aanpassen",
		"Adjust Font Sizing": "Lettergrootte Aanpassen",
		"Reset All": "Alles Resetten",
		Close: "Sluiten",
		// new
		"Choose an accessibility profile": "Kies een toegankelijkheidsprofiel",
		"Motor Impaired": "Motorisch Beperkt",
		"Blind Users": "Blinde Gebruikers",
		"Color Blind": "Kleurenblind",
		Dyslexia: "Dyslexie",
		"Low vision": "Slechtziend",
		"Cognitive Learning": "Cognitief en Leren",
		"Seizure & Epileptic": "Aanvallen en Epilepsie",
		"ADHD  Profile": "ADHD-vriendelijk Profiel",
		"Highlight Titles": "Titels Markeren",
		"Text Alignment": "Tekstuitlijning",
		Dictionary: "Woordenboek",
		Greyscale: "Grijstinten",
		"Color Saturation": "Kleurverzadiging",
		"Page Structure": "Paginastructuur",
		"Big Cursor": "Grote Cursor",
		"Pointer Trail": "Aanwijzerspoor",
		"Click Spark": "Klik Vonk",
		"Image Trails": "Afbeeldingssporen",
		"Screen reader": "Schermlezer",
		"Reading mask": "Leesmasker",
		"Pause animations": "Animaties pauzeren",
		"Reading Guide": "Leesgids",
		"Hide images": "Afbeeldingen verbergen",
		"Outline focus": "Focus omlijning",
		"Highlight Hover": "Hover markering",
		"Magnify Images": "Afbeeldingen vergroten",
		Tooltips: "Tooltips",
		// Category/Section titles
		"Content Adjustments": "Inhoud Aanpassingen",
		"Navigation Adjustments": "Navigatie Aanpassingen",
		"Orientation Adjustments": "Oriëntatie Aanpassingen",
	},
	it_IT: {
		"Accessibility Adjustments": "Regolazioni Accessibilità",
		"Adjust accessibility settings to improve your experience":
			"Regola le impostazioni di accessibilità per migliorare la tua esperienza",
		"Content Scaling": "Ridimensionamento Contenuto",
		"Text Size": "Dimensione Testo",
		"Line Height": "Altezza Riga",
		"Letter Spacing": "Spaziatura Lettere",
		"Color Adjustments": "Regolazioni Colore",
		Contrast: "Contrasto",
		Saturation: "Saturazione",
		Navigation: "Navigazione",
		"Reading Features": "Funzioni di Lettura",
		Premium: "Premium",
		light: "leggero",
		medium: "medio",
		heavy: "pesante",
		"Bigger Text": "Testo Più Grande",
		"Highlight Links": "Evidenzia Collegamenti",
		"Readable Font": "Font Leggibile",
		"Reading Mask": "Maschera di Lettura",
		"Dyslexia Friendly": "Amichevole Dislessia",
		"Content Alignment": "Allineamento Contenuto",
		"Adjust Letter Spacing": "Regola Spaziatura Lettere",
		"Adjust Line Height": "Regola Altezza Riga",
		"Adjust Font Sizing": "Regola Dimensione Font",
		"Reset All": "Ripristina Tutto",
		Close: "Chiudi",
		// new
		"Choose an accessibility profile": "Scegli un profilo di accessibilità",
		"Motor Impaired": "Disabilità Motorie",
		"Blind Users": "Utenti Ciechi",
		"Color Blind": "Daltonismo",
		Dyslexia: "Dislessia",
		"Low vision": "Ipovedenza",
		"Cognitive Learning": "Cognitivo e Apprendimento",
		"Seizure & Epileptic": "Epilessia e Convulsioni",
		"ADHD  Profile": "Profilo ADHD Amichevole",
		"Highlight Titles": "Evidenzia Titoli",
		"Text Alignment": "Allineamento Testo",
		Dictionary: "Dizionario",
		Greyscale: "Scala di Grigi",
		"Color Saturation": "Saturazione Colore",
		"Page Structure": "Struttura Pagina",
		"Big Cursor": "Cursore Grande",
		"Pointer Trail": "Traccia Puntatore",
		"Click Spark": "Scintilla Clic",
		"Image Trails": "Tracce Immagini",
		"Screen reader": "Lettore schermo",
		"Reading mask": "Maschera lettura",
		"Pause animations": "Sospendi animazioni",
		"Reading Guide": "Guida Lettura",
		"Hide images": "Nascondi immagini",
		"Outline focus": "Contorno focus",
		"Highlight Hover": "Evidenzia hover",
		"Magnify Images": "Ingrandisci Immagini",
		Tooltips: "Suggerimenti",
		// Category/Section titles
		"Content Adjustments": "Regolazioni Contenuto",
		"Navigation Adjustments": "Regolazioni Navigazione",
		"Orientation Adjustments": "Regolazioni Orientamento",
	},
	pl_PL: {
		"Accessibility Adjustments": "Ustawienia Dostępności",
		"Adjust accessibility settings to improve your experience":
			"Dostosuj ustawienia dostępności, aby poprawić swoje doświadczenie",
		"Content Scaling": "Skalowanie Treści",
		"Text Size": "Rozmiar Tekstu",
		"Line Height": "Wysokość Linii",
		"Letter Spacing": "Odstęp Między Literami",
		"Color Adjustments": "Korekty Kolorów",
		Contrast: "Kontrast",
		Saturation: "Nasycenie",
		Navigation: "Nawigacja",
		"Reading Features": "Funkcje Czytania",
		Premium: "Premium",
		light: "jasny",
		medium: "średni",
		heavy: "ciężki",
		"Bigger Text": "Większy Tekst",
		"Highlight Links": "Podświetl Linki",
		"Readable Font": "Czytelna Czcionka",
		"Reading Mask": "Maska Czytania",
		"Dyslexia Friendly": "Przyjazny Dysleksji",
		"Content Alignment": "Wyrównanie Treści",
		"Adjust Letter Spacing": "Dostosuj Odstęp Między Literami",
		"Adjust Line Height": "Dostosuj Wysokość Linii",
		"Adjust Font Sizing": "Dostosuj Rozmiar Czcionki",
		"Reset All": "Zresetuj Wszystko",
		Close: "Zamknij",
		// new
		"Choose an accessibility profile": "Wybierz profil dostępności",
		"Motor Impaired": "Niepełnosprawność Ruchowa",
		"Blind Users": "Niewidomi Użytkownicy",
		"Color Blind": "Daltonizm",
		Dyslexia: "Dysleksja",
		"Low vision": "Słabe widzenie",
		"Cognitive Learning": "Poznawcze i Uczenie się",
		"Seizure & Epileptic": "Napady i Padaczka",
		"ADHD  Profile": "Profil Przyjazny ADHD",
		"Highlight Titles": "Podświetl Tytuły",
		"Text Alignment": "Wyrównanie Tekstu",
		Dictionary: "Słownik",
		Greyscale: "Skala szarości",
		"Color Saturation": "Nasycenie Kolorów",
		"Page Structure": "Struktura Strony",
		"Big Cursor": "Duży Kursor",
		"Pointer Trail": "Ślad Wskaźnika",
		"Click Spark": "Iskra Kliknięcia",
		"Image Trails": "Ślady Obrazów",
		"Screen reader": "Czytnik ekranu",
		"Reading mask": "Maska czytania",
		"Pause animations": "Wstrzymaj animacje",
		"Reading Guide": "Przewodnik Czytania",
		"Hide images": "Ukryj obrazy",
		"Outline focus": "Kontur ostrości",
		"Highlight Hover": "Podświetlenie najechania",
		"Magnify Images": "Powiększ Obrazy",
		Tooltips: "Podpowiedzi",
		// Category/Section titles
		"Content Adjustments": "Dostosowania Treści",
		"Navigation Adjustments": "Dostosowania Nawigacji",
		"Orientation Adjustments": "Dostosowania Orientacji",
	},
	cs_CZ: {
		"Accessibility Adjustments": "Úpravy Přístupnosti",
		"Adjust accessibility settings to improve your experience":
			"Upravte nastavení přístupnosti pro zlepšení vašeho zážitku",
		"Content Scaling": "Změna Velikosti Obsahu",
		"Text Size": "Velikost Textu",
		"Line Height": "Výška Řádku",
		"Letter Spacing": "Rozestup Písmen",
		"Color Adjustments": "Úpravy Barev",
		Contrast: "Kontrast",
		Saturation: "Sytost",
		Navigation: "Navigace",
		"Reading Features": "Funkce Čtení",
		Premium: "Premium",
		light: "světlý",
		medium: "střední",
		heavy: "těžký",
		"Bigger Text": "Větší Text",
		"Highlight Links": "Zvýraznit Odkazy",
		"Readable Font": "Čitelné Písmo",
		"Reading Mask": "Maska Čtení",
		"Dyslexia Friendly": "Přátelský k Dyslexii",
		"Content Alignment": "Zarovnání Obsahu",
		"Adjust Letter Spacing": "Upravit Rozestup Písmen",
		"Adjust Line Height": "Upravit Výšku Řádku",
		"Adjust Font Sizing": "Upravit Velikost Písma",
		"Reset All": "Obnovit Vše",
		Close: "Zavřít",
		// new
		"Choose an accessibility profile": "Vyberte profil přístupnosti",
		"Motor Impaired": "Motorické Postižení",
		"Blind Users": "Nevidomí Uživatelé",
		"Color Blind": "Barvoslepost",
		Dyslexia: "Dyslexie",
		"Low vision": "Slabozrakost",
		"Cognitive Learning": "Kognitivní a Učení",
		"Seizure & Epileptic": "Záchvaty a Epilepsie",
		"ADHD  Profile": "ADHD Přátelský Profil",
		"Highlight Titles": "Zvýraznit Titulky",
		"Text Alignment": "Zarovnání Textu",
		Dictionary: "Slovník",
		Greyscale: "Stupně šedi",
		"Color Saturation": "Sytost Barev",
		"Page Structure": "Struktura Stránky",
		"Big Cursor": "Velký Kurzor",
		"Pointer Trail": "Stopa Ukazatele",
		"Click Spark": "Jiskra Kliknutí",
		"Image Trails": "Stopy Obrázků",
		"Screen reader": "Čtečka obrazovky",
		"Reading mask": "Maska čtení",
		"Pause animations": "Pozastavit animace",
		"Reading Guide": "Průvodce Čtením",
		"Hide images": "Skrýt obrázky",
		"Outline focus": "Obrys zaměření",
		"Highlight Hover": "Zvýraznění najetí",
		"Magnify Images": "Zvětšit Obrázky",
		Tooltips: "Nápověda",
		// Category/Section titles
		"Content Adjustments": "Úpravy Obsahu",
		"Navigation Adjustments": "Úpravy Navigace",
		"Orientation Adjustments": "Úpravy Orientace",
	},
	hu_HU: {
		"Accessibility Adjustments": "Akadálymentességi Beállítások",
		"Adjust accessibility settings to improve your experience":
			"Állítsa be az akadálymentességi beállításokat az élmény javítása érdekében",
		"Content Scaling": "Tartalom Méretezése",
		"Text Size": "Szövegméret",
		"Line Height": "Sormagasság",
		"Letter Spacing": "Betűköz",
		"Color Adjustments": "Színbeállítások",
		Contrast: "Kontraszt",
		Saturation: "Telítettség",
		Navigation: "Navigáció",
		"Reading Features": "Olvasási Funkciók",
		Premium: "Prémium",
		light: "könnyű",
		medium: "közepes",
		heavy: "nehéz",
		"Bigger Text": "Nagyobb Szöveg",
		"Highlight Links": "Linkek Kiemelése",
		"Readable Font": "Olvasható Betűtípus",
		"Reading Mask": "Olvasási Maszk",
		"Dyslexia Friendly": "Diszlexia-barát",
		"Content Alignment": "Tartalom Igazítása",
		"Adjust Letter Spacing": "Betűköz Beállítása",
		"Adjust Line Height": "Sormagasság Beállítása",
		"Adjust Font Sizing": "Betűméret Beállítása",
		"Reset All": "Összes Visszaállítása",
		Close: "Bezárás",
		// new
		"Choose an accessibility profile": "Válasszon akadálymentességi profilt",
		"Motor Impaired": "Mozgássérült",
		"Blind Users": "Vak Felhasználók",
		"Color Blind": "Színvak",
		Dyslexia: "Diszlexia",
		"Low vision": "Gyengénlátó",
		"Cognitive Learning": "Kognitív és Tanulási",
		"Seizure & Epileptic": "Roham és Epilepszia",
		"ADHD  Profile": "ADHD-barát Profil",
		"Highlight Titles": "Címek Kiemelése",
		"Text Alignment": "Szöveg Igazítás",
		Dictionary: "Szótár",
		Greyscale: "Szürkeárnyalatos",
		"Color Saturation": "Színtelítettség",
		"Page Structure": "Oldal Szerkezete",
		"Big Cursor": "Nagy Kurzor",
		"Pointer Trail": "Mutató Nyoma",
		"Click Spark": "Kattintás Szikra",
		"Image Trails": "Kép Nyomok",
		"Screen reader": "Képernyőolvasó",
		"Reading mask": "Olvasási maszk",
		"Pause animations": "Animációk szüneteltetése",
		"Reading Guide": "Olvasási Útmutató",
		"Hide images": "Képek elrejtése",
		"Outline focus": "Körvonal fókusz",
		"Highlight Hover": "Rámutatás kiemelés",
		"Magnify Images": "Képek Nagyítása",
		Tooltips: "Eszköztippek",
		// Category/Section titles
		"Content Adjustments": "Tartalom Beállítások",
		"Navigation Adjustments": "Navigációs Beállítások",
		"Orientation Adjustments": "Tájolási Beállítások",
	},
	uk_UA: {
		"Accessibility Adjustments": "Налаштування Доступності",
		"Adjust accessibility settings to improve your experience":
			"Налаштуйте параметри доступності для покращення вашого досвіду",
		"Content Scaling": "Масштабування Контенту",
		"Text Size": "Розмір Тексту",
		"Line Height": "Висота Рядка",
		"Letter Spacing": "Інтервал Між Літерами",
		"Color Adjustments": "Налаштування Кольорів",
		Contrast: "Контрастність",
		Saturation: "Насиченість",
		Navigation: "Навігація",
		"Reading Features": "Функції Читання",
		Premium: "Преміум",
		light: "легкий",
		medium: "середній",
		heavy: "важкий",
		"Bigger Text": "Збільшити Текст",
		"Highlight Links": "Виділити Посилання",
		"Readable Font": "Читабельний Шрифт",
		"Reading Mask": "Маска Читання",
		"Dyslexia Friendly": "Дружній до Дислексії",
		"Content Alignment": "Вирівнювання Контенту",
		"Adjust Letter Spacing": "Налаштувати Інтервал Між Літерами",
		"Adjust Line Height": "Налаштувати Висоту Рядка",
		"Adjust Font Sizing": "Налаштувати Розмір Шрифту",
		"Reset All": "Скинути Все",
		Close: "Закрити",
		// new
		"Choose an accessibility profile": "Виберіть профіль доступності",
		"Motor Impaired": "Порушення моторики",
		"Blind Users": "Сліпі користувачі",
		"Color Blind": "Дальтонізм",
		Dyslexia: "Дислексія",
		"Low vision": "Слабкий зір",
		"Cognitive Learning": "Когнітивні та навчальні",
		"Seizure & Epileptic": "Судоми та епілепсія",
		"ADHD  Profile": "ADHD-дружній профіль",
		"Highlight Titles": "Виділити заголовки",
		"Text Alignment": "Вирівнювання тексту",
		Dictionary: "Словник",
		Greyscale: "Відтінки сірого",
		"Color Saturation": "Насиченість кольору",
		"Page Structure": "Структура сторінки",
		"Big Cursor": "Великий курсор",
		"Pointer Trail": "Слід вказівника",
		"Click Spark": "Іскра кліка",
		"Image Trails": "Сліди зображень",
		"Screen reader": "Програма читання з екрану",
		"Reading mask": "Маска читання",
		"Pause animations": "Призупинити анімації",
		"Reading Guide": "Посібник з читання",
		"Hide images": "Приховати зображення",
		"Outline focus": "Контур фокусу",
		"Highlight Hover": "Виділення при наведенні",
		"Magnify Images": "Збільшити зображення",
		Tooltips: "Підказки",
		// Category/Section titles
		"Content Adjustments": "Налаштування Контенту",
		"Navigation Adjustments": "Налаштування Навігації",
		"Orientation Adjustments": "Налаштування Орієнтації",
	},
	ro_RO: {
		"Accessibility Adjustments": "Ajustări Accesibilitate",
		"Adjust accessibility settings to improve your experience":
			"Ajustați setările de accesibilitate pentru a vă îmbunătăți experiența",
		"Content Scaling": "Scalarea Conținutului",
		"Text Size": "Dimensiunea Textului",
		"Line Height": "Înălțimea Liniei",
		"Letter Spacing": "Spațierea Literelor",
		"Color Adjustments": "Ajustări Culoare",
		Contrast: "Contrast",
		Saturation: "Saturație",
		Navigation: "Navigare",
		"Reading Features": "Funcții de Citire",
		Premium: "Premium",
		light: "ușor",
		medium: "mediu",
		heavy: "greu",
		"Bigger Text": "Text Mai Mare",
		"Highlight Links": "Evidențiază Link-uri",
		"Readable Font": "Font Lizibil",
		"Reading Mask": "Mască de Citire",
		"Dyslexia Friendly": "Prietenos cu Dislexia",
		"Content Alignment": "Alinierea Conținutului",
		"Adjust Letter Spacing": "Ajustează Spațierea Literelor",
		"Adjust Line Height": "Ajustează Înălțimea Liniei",
		"Adjust Font Sizing": "Ajustează Dimensiunea Fontului",
		"Reset All": "Resetează Tot",
		Close: "Închide",
		// new
		"Choose an accessibility profile": "Alege un profil de accesibilitate",
		"Motor Impaired": "Deficiențe Motorii",
		"Blind Users": "Utilizatori Nevăzători",
		"Color Blind": "Daltonism",
		Dyslexia: "Dislexie",
		"Low vision": "Vedere slabă",
		"Cognitive Learning": "Cognitiv și Învățare",
		"Seizure & Epileptic": "Convulsii și Epilepsie",
		"ADHD  Profile": "Profil Prietenos ADHD",
		"Highlight Titles": "Evidențiază Titluri",
		"Text Alignment": "Alinierea Textului",
		Dictionary: "Dicționar",
		Greyscale: "Tonuri de gri",
		"Color Saturation": "Saturația Culorii",
		"Page Structure": "Structura Paginii",
		"Big Cursor": "Cursor Mare",
		"Pointer Trail": "Urmă Pointer",
		"Click Spark": "Scânteie Click",
		"Image Trails": "Urme Imagini",
		"Screen reader": "Cititor ecran",
		"Reading mask": "Mască citire",
		"Pause animations": "Întrerupere animații",
		"Reading Guide": "Ghid de Citire",
		"Hide images": "Ascunde imaginile",
		"Outline focus": "Contur focus",
		"Highlight Hover": "Evidențiere hover",
		"Magnify Images": "Mărește Imaginile",
		Tooltips: "Sfaturi",
		// Category/Section titles
		"Content Adjustments": "Ajustări Conținut",
		"Navigation Adjustments": "Ajustări Navigare",
		"Orientation Adjustments": "Ajustări Orientare",
	},
	el_GR: {
		"Accessibility Adjustments": "Ρυθμίσεις Προσβασιμότητας",
		"Adjust accessibility settings to improve your experience":
			"Προσαρμόστε τις ρυθμίσεις προσβασιμότητας για να βελτιώσετε την εμπειρία σας",
		"Content Scaling": "Κλιμάκωση Περιεχομένου",
		"Text Size": "Μέγεθος Κειμένου",
		"Line Height": "Ύψος Γραμμής",
		"Letter Spacing": "Διάστημα Γραμμάτων",
		"Color Adjustments": "Προσαρμογές Χρώματος",
		Contrast: "Αντίθεση",
		Saturation: "Κορεσμός",
		Navigation: "Πλοήγηση",
		"Reading Features": "Λειτουργίες Ανάγνωσης",
		Premium: "Premium",
		light: "ελαφρύ",
		medium: "μεσαίο",
		heavy: "βαρύ",
		"Bigger Text": "Μεγαλύτερο Κείμενο",
		"Highlight Links": "Επισήμανση Συνδέσμων",
		"Readable Font": "Ευανάγνωστη Γραμματοσειρά",
		"Reading Mask": "Μάσκα Ανάγνωσης",
		"Dyslexia Friendly": "Φιλικό προς Δυslεξία",
		"Content Alignment": "Στοίχιση Περιεχομένου",
		"Adjust Letter Spacing": "Προσαρμογή Διαστήματος Γραμμάτων",
		"Adjust Line Height": "Προσαρμογή Ύψους Γραμμής",
		"Adjust Font Sizing": "Προσαρμογή Μεγέθους Γραμματοσειράς",
		"Reset All": "Επαναφορά Όλων",
		Close: "Κλείσιμο",
		// new
		"Choose an accessibility profile": "Επιλέξτε ένα προφίλ προσβασιμότητας",
		"Motor Impaired": "Κινητικές Βλάβες",
		"Blind Users": "Τυφλοί Χρήστες",
		"Color Blind": "Αχρωματοψία",
		Dyslexia: "Δυσλεξία",
		"Low vision": "Μειωμένη όραση",
		"Cognitive Learning": "Γνωστικά και Μάθηση",
		"Seizure & Epileptic": "Κρίσεις και Επιληψία",
		"ADHD  Profile": "Φιλικό προφίλ ADHD",
		"Highlight Titles": "Επισήμανση Τίτλων",
		"Text Alignment": "Στοίχιση Κειμένου",
		Dictionary: "Λεξικό",
		Greyscale: "Αποχρώσεις του γκρι",
		"Color Saturation": "Κορεσμός Χρώματος",
		"Page Structure": "Δομή Σελίδας",
		"Big Cursor": "Μεγάλος Δρομέας",
		"Pointer Trail": "Ίχνος Δείκτη",
		"Click Spark": "Σπίθα Κλικ",
		"Image Trails": "Ίχνη Εικόνων",
		"Screen reader": "Αναγνώστης οθόνης",
		"Reading mask": "Μάσκα ανάγνωσης",
		"Pause animations": "Παύση κινούμενων σχεδίων",
		"Reading Guide": "Οδηγός Ανάγνωσης",
		"Hide images": "Απόκρυψη εικόνων",
		"Outline focus": "Περίγραμμα εστίασης",
		"Highlight Hover": "Επισήμανση αιώρησης",
		"Magnify Images": "Μεγέθυνση Εικόνων",
		Tooltips: "Συμβουλές εργαλείων",
		// Category/Section titles
		"Content Adjustments": "Προσαρμογές Περιεχομένου",
		"Navigation Adjustments": "Προσαρμογές Πλοήγησης",
		"Orientation Adjustments": "Προσαρμογές Προσανατολισμού",
	},
	he_IL: {
		"Accessibility Adjustments": "התאמות נגישות",
		"Adjust accessibility settings to improve your experience":
			"התאם הגדרות נגישות לשיפור החוויה שלך",
		"Content Scaling": "שינוי קנה מידה של תוכן",
		"Text Size": "גודל טקסט",
		"Line Height": "גובה שורה",
		"Letter Spacing": "ריווח בין אותיות",
		"Color Adjustments": "התאמות צבע",
		Contrast: "ניגודיות",
		Saturation: "רוויה",
		Navigation: "ניווט",
		"Reading Features": "תכונות קריאה",
		Premium: "פרימיום",
		light: "קל",
		medium: "בינוני",
		heavy: "כבד",
		"Bigger Text": "טקסט גדול יותר",
		"Highlight Links": "הדגש קישורים",
		"Readable Font": "גופן קריא",
		"Reading Mask": "מסכת קריאה",
		"Dyslexia Friendly": "ידידותי לדיסלקסיה",
		"Content Alignment": "יישור תוכן",
		"Adjust Letter Spacing": "התאם ריווח בין אותיות",
		"Adjust Line Height": "התאם גובה שורה",
		"Adjust Font Sizing": "התאם גודל גופן",
		"Reset All": "אפס הכל",
		Close: "סגור",
		// new
		"Choose an accessibility profile": "בחר פרופיל נגישות",
		"Motor Impaired": "פגיעה מוטורית",
		"Blind Users": "משתמשים עיוורים",
		"Color Blind": "עיוורון צבעים",
		Dyslexia: "דיסלקסיה",
		"Low vision": "ראייה חלשה",
		"Cognitive Learning": "קוגניטיבי ולמידה",
		"Seizure & Epileptic": "התקפים ואפילפסיה",
		"ADHD  Profile": "פרופיל ידידותי ל-ADHD",
		"Highlight Titles": "הדגש כותרות",
		"Text Alignment": "יישור טקסט",
		Dictionary: "מילון",
		Greyscale: "גווני אפור",
		"Color Saturation": "רוויית צבע",
		"Page Structure": "מבנה עמוד",
		"Big Cursor": "סמן גדול",
		"Pointer Trail": "שביל מצביע",
		"Click Spark": "ניצוץ לחיצה",
		"Image Trails": "שבילי תמונה",
		"Screen reader": "קורא מסך",
		"Reading mask": "מסכת קריאה",
		"Pause animations": "השהה אנימציות",
		"Reading Guide": "מדריך קריאה",
		"Hide images": "הסתר תמונות",
		"Outline focus": "מיקוד מתאר",
		"Highlight Hover": "הדגשת ריחוף",
		"Magnify Images": "הגדל תמונות",
		Tooltips: "עצות כלים",
		// Category/Section titles
		"Content Adjustments": "התאמות תוכן",
		"Navigation Adjustments": "התאמות ניווט",
		"Orientation Adjustments": "התאמות כיוון",
	},
	vi_VN: {
		"Accessibility Adjustments": "Điều Chỉnh Khả Năng Tiếp Cận",
		"Adjust accessibility settings to improve your experience":
			"Điều chỉnh cài đặt khả năng tiếp cận để cải thiện trải nghiệm của bạn",
		"Content Scaling": "Tỷ Lệ Nội Dung",
		"Text Size": "Kích Thước Văn Bản",
		"Line Height": "Chiều Cao Dòng",
		"Letter Spacing": "Khoảng Cách Chữ",
		"Color Adjustments": "Điều Chỉnh Màu Sắc",
		Contrast: "Độ Tương Phản",
		Saturation: "Độ Bão Hòa",
		Navigation: "Điều Hướng",
		"Reading Features": "Tính Năng Đọc",
		Premium: "Cao Cấp",
		light: "nhẹ",
		medium: "trung bình",
		heavy: "nặng",
		"Bigger Text": "Văn Bản Lớn Hơn",
		"Highlight Links": "Tô Sáng Liên Kết",
		"Readable Font": "Phông Chữ Dễ Đọc",
		"Reading Mask": "Mặt Nạ Đọc",
		"Dyslexia Friendly": "Thân Thiện Với Khó Đọc",
		"Content Alignment": "Căn Chỉnh Nội Dung",
		"Adjust Letter Spacing": "Điều Chỉnh Khoảng Cách Chữ",
		"Adjust Line Height": "Điều Chỉnh Chiều Cao Dòng",
		"Adjust Font Sizing": "Điều Chỉnh Kích Thước Phông Chữ",
		"Reset All": "Đặt Lại Tất Cả",
		Close: "Đóng",
		// new
		"Choose an accessibility profile": "Chọn hồ sơ khả năng tiếp cận",
		"Motor Impaired": "Khuyết Tật Vận Động",
		"Blind Users": "Người Dùng Mù",
		"Color Blind": "Mù Màu",
		Dyslexia: "Khó Đọc",
		"Low vision": "Thị lực kém",
		"Cognitive Learning": "Nhận Thức và Học Tập",
		"Seizure & Epileptic": "Co Giật và Động Kinh",
		"ADHD  Profile": "Hồ Sơ Thân Thiện ADHD",
		"Highlight Titles": "Tô Sáng Tiêu Đề",
		"Text Alignment": "Căn Chỉnh Văn Bản",
		Dictionary: "Từ Điển",
		Greyscale: "Thang độ xám",
		"Color Saturation": "Độ Bão Hòa Màu",
		"Page Structure": "Cấu Trúc Trang",
		"Big Cursor": "Con Trỏ Lớn",
		"Pointer Trail": "Dấu Vết Con Trỏ",
		"Click Spark": "Tia Lửa Nhấp Chuột",
		"Image Trails": "Dấu Vết Hình Ảnh",
		"Screen reader": "Trình đọc màn hình",
		"Reading mask": "Mặt nạ đọc",
		"Pause animations": "Tạm dừng hoạt ảnh",
		"Reading Guide": "Hướng Dẫn Đọc",
		"Hide images": "Ẩn hình ảnh",
		"Outline focus": "Đường viền tiêu điểm",
		"Highlight Hover": "Tô sáng khi di chuột",
		"Magnify Images": "Phóng To Hình Ảnh",
		Tooltips: "Chú thích công cụ",
		// Category/Section titles
		"Content Adjustments": "Điều Chỉnh Nội Dung",
		"Navigation Adjustments": "Điều Chỉnh Điều Hướng",
		"Orientation Adjustments": "Điều Chỉnh Định Hướng",
	},
	th_TH: {
		"Accessibility Adjustments": "การปรับแต่งการเข้าถึง",
		"Adjust accessibility settings to improve your experience":
			"ปรับการตั้งค่าการเข้าถึงเพื่อปรับปรุงประสบการณ์ของคุณ",
		"Content Scaling": "การปรับขนาดเนื้อหา",
		"Text Size": "ขนาดข้อความ",
		"Line Height": "ความสูงของบรรทัด",
		"Letter Spacing": "ระยะห่างของตัวอักษร",
		"Color Adjustments": "การปรับสี",
		Contrast: "ความเปรียบต่าง",
		Saturation: "ความอิ่มตัว",
		Navigation: "การนำทาง",
		"Reading Features": "คุณสมบัติการอ่าน",
		Premium: "พรีเมี่ยม",
		light: "เบา",
		medium: "ปานกลาง",
		heavy: "หนัก",
		"Bigger Text": "ข้อความใหญ่ขึ้น",
		"Highlight Links": "เน้นลิงก์",
		"Readable Font": "แบบอักษรที่อ่านง่าย",
		"Reading Mask": "หน้ากากการอ่าน",
		"Dyslexia Friendly": "เป็นมิตรกับดิสเล็กเซีย",
		"Content Alignment": "การจัดเรียงเนื้อหา",
		"Adjust Letter Spacing": "ปรับระยะห่างของตัวอักษร",
		"Adjust Line Height": "ปรับความสูงของบรรทัด",
		"Adjust Font Sizing": "ปรับขนาดแบบอักษร",
		"Reset All": "รีเซ็ตทั้งหมด",
		Close: "ปิด",
		// new
		"Choose an accessibility profile": "เลือกโปรไฟล์การเข้าถึง",
		"Motor Impaired": "ความพิการทางการเคลื่อนไหว",
		"Blind Users": "ผู้ใช้ตาบอด",
		"Color Blind": "ตาบอดสี",
		Dyslexia: "ดิสเล็กเซีย",
		"Low vision": "การมองเห็นต่ำ",
		"Cognitive Learning": "การรับรู้และการเรียนรู้",
		"Seizure & Epileptic": "อาการชักและโรคลมชัก",
		"ADHD  Profile": "โปรไฟล์เป็นมิตรกับ ADHD",
		"Highlight Titles": "เน้นหัวข้อ",
		"Text Alignment": "การจัดแนวข้อความ",
		Dictionary: "พจนานุกรม",
		Greyscale: "สีเทา",
		"Color Saturation": "ความอิ่มตัวของสี",
		"Page Structure": "โครงสร้างหน้า",
		"Big Cursor": "เคอร์เซอร์ใหญ่",
		"Pointer Trail": "รอยตัวชี้",
		"Click Spark": "ประกายคลิก",
		"Image Trails": "รอยภาพ",
		"Screen reader": "โปรแกรมอ่านหน้าจอ",
		"Reading mask": "หน้ากากอ่าน",
		"Pause animations": "หยุดแอนิเมชั่นชั่วคราว",
		"Reading Guide": "คู่มือการอ่าน",
		"Hide images": "ซ่อนภาพ",
		"Outline focus": "โครงร่างโฟกัส",
		"Highlight Hover": "เน้นเมื่อชี้",
		"Magnify Images": "ขยายภาพ",
		Tooltips: "คำแนะนำเครื่องมือ",
		// Category/Section titles
		"Content Adjustments": "การปรับเนื้อหา",
		"Navigation Adjustments": "การปรับการนำทาง",
		"Orientation Adjustments": "การปรับการปฐมนิเทศ",
	},
	ms_MY: {
		"Accessibility Adjustments": "Pelarasan Kebolehcapaian",
		"Adjust accessibility settings to improve your experience":
			"Sesuaikan tetapan kebolehcapaian untuk meningkatkan pengalaman anda",
		"Content Scaling": "Penskalaan Kandungan",
		"Text Size": "Saiz Teks",
		"Line Height": "Ketinggian Baris",
		"Letter Spacing": "Jarak Huruf",
		"Color Adjustments": "Pelarasan Warna",
		Contrast: "Kontras",
		Saturation: "Ketepuan",
		Navigation: "Navigasi",
		"Reading Features": "Ciri-ciri Membaca",
		Premium: "Premium",
		light: "ringan",
		medium: "sederhana",
		heavy: "berat",
		"Bigger Text": "Teks Lebih Besar",
		"Highlight Links": "Serlahkan Pautan",
		"Readable Font": "Fon Yang Boleh Dibaca",
		"Reading Mask": "Topeng Membaca",
		"Dyslexia Friendly": "Mesra Disleksia",
		"Content Alignment": "Penjajaran Kandungan",
		"Adjust Letter Spacing": "Laraskan Jarak Huruf",
		"Adjust Line Height": "Laraskan Ketinggian Baris",
		"Adjust Font Sizing": "Laraskan Saiz Fon",
		"Reset All": "Set Semula Semua",
		Close: "Tutup",
		// Category/Section titles
		"Content Adjustments": "Pelarasan Kandungan",
		"Navigation Adjustments": "Pelarasan Navigasi",
		"Orientation Adjustments": "Pelarasan Orientasi",
	},
	id_ID: {
		"Accessibility Adjustments": "Penyesuaian Aksesibilitas",
		"Adjust accessibility settings to improve your experience":
			"Sesuaikan pengaturan aksesibilitas untuk meningkatkan pengalaman Anda",
		"Content Scaling": "Penskalaan Konten",
		"Text Size": "Ukuran Teks",
		"Line Height": "Tinggi Baris",
		"Letter Spacing": "Spasi Huruf",
		"Color Adjustments": "Penyesuaian Warna",
		Contrast: "Kontras",
		Saturation: "Saturasi",
		Navigation: "Navigasi",
		"Reading Features": "Fitur Membaca",
		Premium: "Premium",
		light: "ringan",
		medium: "sedang",
		heavy: "berat",
		"Bigger Text": "Teks Lebih Besar",
		"Highlight Links": "Sorot Tautan",
		"Readable Font": "Font Yang Mudah Dibaca",
		"Reading Mask": "Masker Baca",
		"Dyslexia Friendly": "Ramah Disleksia",
		"Content Alignment": "Penyelarasan Konten",
		"Adjust Letter Spacing": "Sesuaikan Spasi Huruf",
		"Adjust Line Height": "Sesuaikan Tinggi Baris",
		"Adjust Font Sizing": "Sesuaikan Ukuran Font",
		"Reset All": "Reset Semua",
		Close: "Tutup",
		// Category/Section titles
		"Content Adjustments": "Penyesuaian Konten",
		"Navigation Adjustments": "Penyesuaian Navigasi",
		"Orientation Adjustments": "Penyesuaian Orientasi",
	},
	sv_SE: {
		"Accessibility Adjustments": "Tillgänglighetsjusteringar",
		"Adjust accessibility settings to improve your experience":
			"Justera tillgänglighetsinställningar för att förbättra din upplevelse",
		"Content Scaling": "Innehållsskalning",
		"Text Size": "Textstorlek",
		"Line Height": "Radhöjd",
		"Letter Spacing": "Bokstavsavstånd",
		"Color Adjustments": "Färgjusteringar",
		Contrast: "Kontrast",
		Saturation: "Mättnad",
		Navigation: "Navigation",
		"Reading Features": "Läsfunktioner",
		Premium: "Premium",
		light: "ljus",
		medium: "medium",
		heavy: "tung",
		"Bigger Text": "Större Text",
		"Highlight Links": "Markera Länkar",
		"Readable Font": "Läsbart Teckensnitt",
		"Reading Mask": "Läsmask",
		"Dyslexia Friendly": "Dyslexi-vänlig",
		"Content Alignment": "Innehållsjustering",
		"Adjust Letter Spacing": "Justera Bokstavsavstånd",
		"Adjust Line Height": "Justera Radhöjd",
		"Adjust Font Sizing": "Justera Teckenstorlek",
		"Reset All": "Återställ Allt",
		Close: "Stäng",
		// Category/Section titles
		"Content Adjustments": "Innehållsjusteringar",
		"Navigation Adjustments": "Navigationsjusteringar",
		"Orientation Adjustments": "Orienteringsjusteringar",
	},
	nb_NO: {
		"Accessibility Adjustments": "Tilgjengelighetsjusteringer",
		"Adjust accessibility settings to improve your experience":
			"Juster tilgjengelighetsinnstillinger for å forbedre din opplevelse",
		"Content Scaling": "Innholdsskalering",
		"Text Size": "Tekststørrelse",
		"Line Height": "Linjehøyde",
		"Letter Spacing": "Bokstavmellomrom",
		"Color Adjustments": "Fargejusteringer",
		Contrast: "Kontrast",
		Saturation: "Metning",
		Navigation: "Navigering",
		"Reading Features": "Lesefunksjoner",
		Premium: "Premium",
		light: "lys",
		medium: "medium",
		heavy: "tung",
		"Bigger Text": "Større Tekst",
		"Highlight Links": "Fremhev Lenker",
		"Readable Font": "Lesbar Skrift",
		"Reading Mask": "Lesemaske",
		"Dyslexia Friendly": "Dysleksivennlig",
		"Content Alignment": "Innholdsjustering",
		"Adjust Letter Spacing": "Juster Bokstavmellomrom",
		"Adjust Line Height": "Juster Linjehøyde",
		"Adjust Font Sizing": "Juster Skriftstørrelse",
		"Reset All": "Tilbakestill Alt",
		Close: "Lukk",
		// Category/Section titles
		"Content Adjustments": "Innholdsjusteringer",
		"Navigation Adjustments": "Navigeringsjusteringer",
		"Orientation Adjustments": "Orienteringsjusteringer",
	},
	da_DK: {
		"Accessibility Adjustments": "Tilgængelighedsjusteringer",
		"Adjust accessibility settings to improve your experience":
			"Juster tilgængelighedsindstillinger for at forbedre din oplevelse",
		"Content Scaling": "Indholdsskalering",
		"Text Size": "Tekststørrelse",
		"Line Height": "Linjehøjde",
		"Letter Spacing": "Bogstavafstand",
		"Color Adjustments": "Farvejusteringer",
		Contrast: "Kontrast",
		Saturation: "Mætning",
		Navigation: "Navigation",
		"Reading Features": "Læsefunktioner",
		Premium: "Premium",
		light: "lys",
		medium: "medium",
		heavy: "tung",
		"Bigger Text": "Større Tekst",
		"Highlight Links": "Fremhæv Links",
		"Readable Font": "Læsbar Skrifttype",
		"Reading Mask": "Læsemaske",
		"Dyslexia Friendly": "Ordblind-venlig",
		"Content Alignment": "Indholdsjustering",
		"Adjust Letter Spacing": "Juster Bogstavafstand",
		"Adjust Line Height": "Juster Linjehøjde",
		"Adjust Font Sizing": "Juster Skriftstørrelse",
		"Reset All": "Nulstil Alt",
		Close: "Luk",
		// Category/Section titles
		"Content Adjustments": "Indholdsjusteringer",
		"Navigation Adjustments": "Navigationsjusteringer",
		"Orientation Adjustments": "Orienteringsjusteringer",
	},
	fi_FI: {
		"Accessibility Adjustments": "Esteettömyyssäädöt",
		"Adjust accessibility settings to improve your experience":
			"Säädä esteettömyysasetuksia parantaaksesi kokemustasi",
		"Content Scaling": "Sisällön Skaalaus",
		"Text Size": "Tekstin Koko",
		"Line Height": "Rivin Korkeus",
		"Letter Spacing": "Kirjainväli",
		"Color Adjustments": "Värisäädöt",
		Contrast: "Kontrasti",
		Saturation: "Kylläisyys",
		Navigation: "Navigointi",
		"Reading Features": "Lukuominaisuudet",
		Premium: "Premium",
		light: "kevyt",
		medium: "keskiverto",
		heavy: "raskas",
		"Bigger Text": "Isompi Teksti",
		"Highlight Links": "Korosta Linkit",
		"Readable Font": "Luettava Fontti",
		"Reading Mask": "Lukumaski",
		"Dyslexia Friendly": "Lukihäiriöystävällinen",
		"Content Alignment": "Sisällön Tasaus",
		"Adjust Letter Spacing": "Säädä Kirjainväliä",
		"Adjust Line Height": "Säädä Rivin Korkeutta",
		"Adjust Font Sizing": "Säädä Fontin Kokoa",
		"Reset All": "Nollaa Kaikki",
		Close: "Sulje",
		// Category/Section titles
		"Content Adjustments": "Sisältösäädöt",
		"Navigation Adjustments": "Navigointisäädöt",
		"Orientation Adjustments": "Suuntaussäädöt",
	},
	fa_IR: {
		"Accessibility Adjustments": "تنظیمات دسترسی",
		"Adjust accessibility settings to improve your experience":
			"تنظیمات دسترسی را برای بهبود تجربه خود تنظیم کنید",
		"Content Scaling": "مقیاس‌بندی محتوا",
		"Text Size": "اندازه متن",
		"Line Height": "ارتفاع خط",
		"Letter Spacing": "فاصله حروف",
		"Color Adjustments": "تنظیمات رنگ",
		Contrast: "کنتراست",
		Saturation: "اشباع",
		Navigation: "ناوبری",
		"Reading Features": "ویژگی‌های خواندن",
		Premium: "پریمیوم",
		light: "سبک",
		medium: "متوسط",
		heavy: "سنگین",
		"Bigger Text": "متن بزرگ‌تر",
		"Highlight Links": "برجسته کردن پیوندها",
		"Readable Font": "فونت خوانا",
		"Reading Mask": "ماسک خواندن",
		"Dyslexia Friendly": "دوستدار نارساخوانی",
		"Content Alignment": "تراز محتوا",
		"Adjust Letter Spacing": "تنظیم فاصله حروف",
		"Adjust Line Height": "تنظیم ارتفاع خط",
		"Adjust Font Sizing": "تنظیم اندازه فونت",
		"Reset All": "بازنشانی همه",
		Close: "بستن",
		// Category/Section titles
		"Content Adjustments": "تنظیمات محتوا",
		"Navigation Adjustments": "تنظیمات ناوبری",
		"Orientation Adjustments": "تنظیمات جهت‌گیری",
	},
};
